import { CloseOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

export const StyledErrorItem = styled.li`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const StyledErrorList = styled.ul`
  list-style: none;
  margin-bottom: 0;
  padding-inline-start: 0;
  font-weight: bold;
`;

// Would be nice if we could use ::marker instead of this.
// But imported icons don't work, or background-color. Workarounds seem more complicated than the below
export const StyledErrorIcon = styled(CloseOutlined)`
  padding: ${({ theme }) => theme.spacing.space_2};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.reds.red};
  color: ${({ theme }) => theme.palette.white};
  margin-right: ${({ theme }) => theme.spacing.space_3};
  & svg {
    height: 8px;
    width: 8px;
  }
`;
